import store from '@/store'
import { countryConfig } from '@/config'
import { router } from '../main'
import { BigNumber } from 'bignumber.js'
import { i18n } from '@/main.js'
import mutationsTypes from '@/store/mutationTypes'

export default {
  async bulkGetMasterData() {
    const masterList = [
      'Common/getConsumptionTaxListFromApi',
      'Common/getCurrencyListFromApi',
      'Common/getCountryListFromApi',
      'Common/getCountryCallingCodeListFromApi',
      'Common/getProductCategoryListFromApi',
      'Common/getOftenUseScreenListFromApi',
      'Common/getStockAdjustReasonListFromApi'
    ].reduce((previousValue, currentValue) => {
      previousValue.push(store.dispatch(currentValue))
      return previousValue
    }, [])

    return await Promise.all(masterList).then((message) => {
      // console.log('message : ' + message)
    })
  },
  hasRegisteredUserInfo(response, isUserInfo = false) {
    // 必要情報未登録のユーザの場合、各APIはユーザ情報を返却する
    if (!isUserInfo) {
      if (!response.data.id) return
      if (response.data.emailVerifiedAt) {
        router.push({ name: 'user.profile' }).catch(() => {})
        return
      } else {
        router.push({ name: 'Login' }).catch(() => {})
        return
      }
    }
  },
  afterApiSuccessProcess(response, getData) {
    return {
      code: response.status,
      message: response.statusText,
      data: getData
    }
  },
  afterApiFailProcess(response) {
    switch (response.status) {
      case 400:
        alert(response.data.message)
        return
      case 401:
      case 419:
        //         this.displayAlertAndRouterPush(
        //           `認証に失敗しました。
        // 再度ログインしてください。`,
        //           'Login'
        //         )
        router
          .push({
            name: 'Login'
          })
          .catch(() => {})
        return
      case 403:
        alert(`${i18n.tc('common.error_auth-mail-expired')}
${i18n.tc('common.error_auth-mail-resend')}`)
        store.dispatch('Auth/mailVerifyResend')
        return
      case 422:
        alert(this.getApiValidationErrorMessage(response))
        return
      case 503:
        router
          .push({
            name: 'maintenance'
          })
          .catch(() => {})
        return
      default:
        // TODO: ひとまずログインへ遷移
        //         this.displayAlertAndRouterPush(
        //           `予期せぬエラーが発生しました。
        // 再度時間をおいて実行してください。`,
        //           'Login'
        //         )
        alert(`${i18n.tc('common.error_unexpected-error-occured')}
${i18n.tc('common.error_do-it-later')}`)
        return
    }
  },
  getApiValidationErrorMessage(response) {
    let returnMessage = ''
    for (let error of Object.keys(response.data.errors)) {
      returnMessage += response.data.errors[error].reduce((result, message) => {
        return result + message + '\n'
      }, '')
    }
    return returnMessage
  },
  displayAlertAndRouterPush(alertMessage, destination) {
    const hasDisplayed = store.getters['Common/getHasDisplayedAlertFlg']

    if (hasDisplayed) return
    store.dispatch('Common/setHasDisplayedAlertFlg', { hasDisplayed: true })
    alert(alertMessage)

    router
      .push({
        name: destination
      })
      .catch(() => {})
  },
  // 販売、発注履歴などの状態定数をセレクトボックス用のobjectリストに整形
  getStatusHistoryIdNameList(dict, statusLabel) {
    const ret = []
    for (let key in dict) {
      if (key !== 'ALL') {
        ret.push({
          value: dict[key],
          label: i18n.tc(statusLabel[key])
        })
      }
    }
    return this.sortStatusHistoryIdNameList(ret)
  },
  // セレクトボックス用のobjectリストをvalue順にソートする
  sortStatusHistoryIdNameList(list) {
    return list.sort((ele1, ele2) => {
      if (ele1.value < ele2.value) {
        return -1
      }
      if (ele1.value > ele2.value) {
        return 1
      }
      return 0
    })
  },
  // ステータス履歴のリストからidに対応するデータの要素名を返す
  getStatusHistoryLabelById(list, id) {
    const ele = list.find((ele) => ele.value === id)
    return list ? (ele ? ele.label : '-') : '-'
  },

  nullEmptyFormat(target, str) {
    return target ? target : str
  },
  nullEmptyFormatNull(target) {
    return this.nullEmptyFormat(target, null)
  },
  nullEmptyFormatHyphen(target) {
    return this.nullEmptyFormat(target, '-')
  },
  nullEmptyFormatNashi(target) {
    return this.nullEmptyFormat(target, '(なし)')
  },

  formatRegion(region, isTargetId) {
    const isObject = region && typeof region === 'object'

    const id = isObject ? region.value : null
    const str = isObject ? null : region

    return isTargetId ? id : str
  },
  getRegionValue(region) {
    const isObject = region && typeof region === 'object'
    return isObject ? region.value : region
  },

  // 全件数、1ページあたりの取得数からページ数を取得
  getPageCount(totalRows, perPage) {
    return Math.max(Math.ceil(totalRows / perPage), 1)
  },

  // スペース区切りの表示用文字列を作成
  getSeparateWordsBySpace(arr) {
    return arr
      .filter((ele) => ele)
      .reduce((result, current) => {
        return result + current + ' '
      }, '')
  },

  // APIのDateTime(String)のデータを表示用にDate(String)に変換
  getDateFromDateTimeString(dateTime) {
    if (!dateTime) {
      return ''
    }
    return dateTime.split(' ')[0]
  },
  getToday() {
    const date = new Date()

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return year + '-' + month + '-' + day
  },
  // 1月前の1日を取得する
  getFirstDateOneMonthAgo() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const dt = ('0' + date.getDate()).slice(-2)
    return date.getFullYear() + '-' + month + '-01'
  },
  // 当月の末日を取得する
  getLastDateThisMonth() {
    const tmpDate = new Date()
    const date = new Date(tmpDate.getFullYear(), tmpDate.getMonth() + 1, 0)
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const dt = ('0' + date.getDate()).slice(-2)
    return date.getFullYear() + '-' + month + '-' + dt
  },
  formatPostalCode(postalCode, countryId) {
    if (
      countryConfig.COUNTRY_ID_LIST.JPN === countryId &&
      postalCode &&
      postalCode.length === 7
    ) {
      return postalCode.substr(0, 3) + '-' + postalCode.substr(3, 7)
    }
    return postalCode
  },
  /**
   *
   * @param {*} currencyId 変換元通貨ID
   * @param {*} targetCurrencyId 変換先通貨ID
   * @param {*} price
   * @param {*} fxRateList
   * @returns
   */
  exchangePriceByFxRate(currencyId, targetCurrencyId, price, fxRateList) {
    if (currencyId === targetCurrencyId) return price
    const targetFxRate = fxRateList.find(
      (fxRate) =>
        fxRate.currencyId == currencyId &&
        fxRate.targetCurrencyId == targetCurrencyId
    )
    return targetFxRate ? price * targetFxRate.rate : ''
  },

  async getFxRate(targetDate) {
    const fxRate = await store.dispatch('Common/getFxRateListFromApi', {
      targetDate: targetDate
    })
    return fxRate.data ? fxRate.data : []
  },
  formatPrice(price) {
    return BigNumber(Math.floor(BigNumber(price).times(100).toNumber()))
      .div(100)
      .toNumber()
  }
}
